import { useAuth } from 'context/AuthContext';
import { useTheme } from 'context/ThemeContext';
import { getPrimaryRoleBadge } from 'permissions';
import SystemStatus from 'components/ui/SystemStatus';
import Notifications from 'components/shared/NotificationPanel';

export default function Header({ onToggleSidebar, onOpenSearch }) {
  const { user } = useAuth();
  const { theme, toggle: toggleTheme } = useTheme();
  const roles = user?.roles || (user?.role ? [user.role] : []);

  return (
    <header className="topbar">
      <div className="topbar-left">
        <button className="topbar-toggle" onClick={onToggleSidebar}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
          </svg>
        </button>
        <button className="topbar-search-btn" onClick={onOpenSearch} title="Recherche (Ctrl+K)">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
          <span className="topbar-search-text">Rechercher...</span>
          <kbd className="topbar-kbd">Ctrl+K</kbd>
        </button>
      </div>
      <div className="topbar-right">
        <SystemStatus />
        <Notifications />
        <button className="topbar-theme-btn" onClick={toggleTheme} title={theme === 'light' ? 'Mode sombre' : 'Mode clair'}>
          {theme === 'light' ? (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/></svg>
          ) : (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>
          )}
        </button>
        <span className="topbar-role-badge">{getPrimaryRoleBadge(roles)}</span>
      </div>
    </header>
  );
}
